import { render, staticRenderFns } from "./VideoArchive.vue?vue&type=template&id=c5d0fd68&"
import script from "./VideoArchive.vue?vue&type=script&lang=js&"
export * from "./VideoArchive.vue?vue&type=script&lang=js&"
import style0 from "./VideoArchive.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
installComponents(component, {VCarousel,VCarouselItem})
